// extracted by mini-css-extract-plugin
module.exports = {"orderSummaryShipSection":"aN","deliveryPromiseDate":"bN"};